import { useEffect, useState } from 'react';
import type { User } from 'firebase/auth';
import { subscribeAuth } from './auth';

export type AuthState =
  | { status: 'loading' }
  | { status: 'signed-in'; user: User }
  | { status: 'signed-out' };

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({ status: 'loading' });

  useEffect(() => {
    return subscribeAuth((user) => {
      setState(user ? { status: 'signed-in', user } : { status: 'signed-out' });
    });
  }, []);

  return state;
}
